var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.396 0a.25.25 0 0 1 .177.427L3.005 1.995 6.654 5.6l3.614-3.655L8.75.427A.25.25 0 0 1 8.927 0h4.146a.25.25 0 0 1 .25.25v4.146a.25.25 0 0 1-.427.177l-1.568-1.568-3.606 3.649 3.657 3.614 1.517-1.518a.25.25 0 0 1 .427.177v4.146a.25.25 0 0 1-.25.25H8.927a.25.25 0 0 1-.177-.427l1.568-1.568-3.65-3.606-3.613 3.657 1.518 1.517a.25.25 0 0 1-.177.427H.25a.25.25 0 0 1-.25-.25V8.927a.25.25 0 0 1 .427-.177l1.568 1.568L5.6 6.668 1.945 3.055.427 4.573A.25.25 0 0 1 0 4.396V.25A.25.25 0 0 1 .25 0h4.146z",
    fill: "#87A0B2",
    fillRule: "nonzero"
  })));
};

export default SvgMove;